module.exports = __webpack_public_path__ + "img/add-departure-canceled-table-icon.afb2ce44.svg";